import React, { FunctionComponent, useEffect, useState } from "react";
import MobileNavbar from "./mobile-navbar";
import DesktopNavbar from "./desktop-navbar";
import { ILink } from "./interfaces";

const navbarLinks: ILink[] = [
  {
    text: "About",
    href: "/about",
    sublinks: [{ text: "Team", href: "/team" }],
  },
  {
    text: "Programs",
    href: "/programs",
  },
  {
    text: "News & Events",
    href: "/news-and-events",
    sublinks: [
      { text: "CSG Activities", href: "/resources" },
      { text: "Stempeers2020", href: "/nyc18-2" },
      { text: "EuroSTEMPeers 2020", href: "/post/EuroSTEMPeers-2020_Qwe5Gmx" },
    ],
  },
  {
    text: "Resources",
    href: "/careerresources",
    sublinks: [
      { text: "Blog", href: "/bloglets" },
      { text: "STEMPeers Fellows Program ", href: "/csgfellowship" },
      { text: "Fellowships", href: "/fellowships" },
      {
        text: "STEMPeers Editors Choice",
        external: true,
        href:
          "https://stempeerseditorschoice.wordpress.com/?fbclid=IwAR1Qa9GQT4O3eMBOxp8SXcY8CV3KwKpobWL1yF8FmfIEk8jBdUsGLiJhArE",
      },
      {
        text: "SciWri",
        external: true,
        href: "https://sciwri.club",
      },
      {
        text: "SciExplore",
        external: true,
        href: "https://scixplore.wordpress.com",
      },
    ],
  },
  {
    text: "FAQ",
    href: "/faq",
  },
  {
    text: "Join Us",
    href: "/join-us",
  },
  {
    text: "Advertising and Business Services",
    href: "/advertising-and-business-services",
  },
  {
    text: "Telecommunication Services",
    href: "/telecommunication-services",
  },
  {
    text: "Education Services",
    href: "/education-services",
  },
  {
    text: "Science and Technology Services",
    href: "/science-and-technology-services",
  },
  // {
  //   text: 'Mandatory RCR Training Request',
  //   href: '/mandatory-rcr-training-request',
  // },
];

const LG_BREAKPOINT: number = 1024;

const Navbar: FunctionComponent = () => {
  const [isResponsive, setIsResponsive] = useState<boolean>(true);

  useEffect(() => {
    setIsResponsive(window.innerWidth <= LG_BREAKPOINT);
  }, []);

  return isResponsive ? (
    <MobileNavbar links={navbarLinks} />
  ) : (
    <DesktopNavbar links={navbarLinks} />
  );
};

export default Navbar;
